// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GhSi","type":"styles_type__2Bgkx","choices":"styles_choices__3j5lY"};